/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Payments_Tab_One_TimeInputs */

const en_admin_payments_tab_one_time = /** @type {(inputs: Admin_Payments_Tab_One_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One-Time`)
};

/**
* | output |
* | --- |
* | "One-Time" |
*
* @param {Admin_Payments_Tab_One_TimeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_payments_tab_one_time = /** @type {((inputs?: Admin_Payments_Tab_One_TimeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Payments_Tab_One_TimeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_payments_tab_one_time(inputs)
});
export { admin_payments_tab_one_time as "admin.payments.tab_one_time" }